module.exports = __webpack_public_path__ + "static/img/illus-06.d4bf3d9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-06.webp
// module id = 107
// module chunks = 0